module.exports = __webpack_public_path__ + "static/media/How you can manage task under a client file.bb4ad088.png";